const fxfjgk = [{
  path: 'fxfj_hffxfjdx',
  name: 'fxfj_hffxfjdx',
  component: () =>
            import('@/components/fxfjgk/hffxfxdx'),
  meta: { title: '装置管理', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'fxfj_hffxfjdy',
  name: 'fxfj_hffxfjdy',
  component: () =>
            import('@/components/fxfjgk/hffxfxdy'),
  meta: { title: '单元位置管理', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'fxfj_hffxsj',
  name: 'fxfj_hffxsj',
  component: () =>
            import('@/components/fxfjgk/hffxsj'),
  meta: { title: '风险管控清单', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'fxfj_hffxgk',
  name: 'fxfj_hffxgk',
  component: () =>
            import('@/components/fxfjgk/hffxgk'),
  meta: { title: '风险管控清单管理', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'fxfj_bgsqb',
  name: 'fxfj_bgsqb',
  component: () =>
      import('@/components/fxfjgk/bgsqb'),
  meta: { title: '变更申请表', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'fxfj_bgsqbys',
  name: 'fxfj_bgsqbys',
  component: () =>
      import('@/components/fxfjgk/bgsqbys'),
  meta: { title: '变更申请表验收', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'fxfj_zdhffxgk',
  name: 'fxfj_zdhffxgk',
  component: () =>
            import('@/components/fxfjgk/zdwxygk'),
  meta: { title: '重大风险管控', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'fxfj_hffxsc',
  name: 'fxfj_hffxsc',
  component: () =>
            import('@/components/fxfjgk/hffxsc'),
  meta: { title: '风险上传', requireAuth: true, keepAlive: true, permission: true }
},
{
  path: 'fxfj_hffxtj',
  name: 'fxfj_hffxtj',
  component: () =>
            import('@/components/fxfjgk/hffxtj'),
  meta: { title: '风险统计', requireAuth: true, keepAlive: true, permission: true }
},
// {
//   path: 'fxfj_hffxtj',
//   name: 'fxfj_hffxtj',
//   component: () =>
//             import('@/components/fxfjgk/hffxtj'),
//   meta: { title: '风险统计', requireAuth: true, keepAlive: true, permission: true }
// },
{
  path: 'fxfj_sst',
  name: 'fxfj_sst',
  component: () =>
            import('@/components/fxfjgk/fxtjsst'),
  meta: { title: '安全风险四色图', requireAuth: true, keepAlive: true, permission: true }
}
,
{
  path: 'fxfj_sstGl',
  name: 'fxfj_sstGl',
  component: () =>
            import('@/components/fxfjgk/sst'),
  meta: { title: '四色图管理', requireAuth: true, keepAlive: true, permission: true }
}
]
export default fxfjgk



// WEBPACK FOOTER //
// ./src/router/fxfjgk.js